import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-hotels",
  "use": "icon-ic-list-hotels-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-hotels\"><path d=\"M20.5 3.5c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17 4.7 4.7 12.3 4.7 17 0 2.3-2.2 3.5-5.3 3.5-8.5s-1.3-6.2-3.5-8.5zM12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm4.5-13.7h-5.1V13H6.3V7H5v10h1.3v-2h11.5v2H19v-6c0-1.4-1.1-2.6-2.5-2.7zm-7.7 4c1.1 0 2-.8 2.1-1.9.1-1.1-.8-2-1.9-2.1-1.1 0-2 .8-2.1 1.9v.1c0 1.1.8 2 1.9 2z\" fill=\"#007FBA\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol